// extracted by mini-css-extract-plugin
export default {"container":"R7wUWsr0zUbKzcG5sa1k","fadeIn":"Bikl_TYPUDED37Wcei9s","messageContainer":"M6K_rqs_D5qxIsnrMqDt","message":"xkbwsddeVn1p8eT__JLc","closeButton":"e8RpEfUY7vsfyHjDZC8k"};